// extracted by mini-css-extract-plugin
module.exports = {"glossaryList":"TheoryGlossaryContainer_glossaryList__2WD_y","letterItem":"TheoryGlossaryContainer_letterItem__2Y9FI"};